import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import faBars from '@fortawesome/fontawesome-free-solid/faBars'

import Container from 'layouts/Container'
import { SvgSiteLogo } from 'components/Svg'
import LinkNav from 'components/LinkNav'
import Link from 'components/Link'
import { reverse } from 'utilities/routes'
import { NAME as ROUTE_FIND_ACTIVITY } from 'views/FindActivity/constants'
import { NAME as ROUTE_HOME } from 'views/Home/constants'
import { NAME as ROUTE_LOGIN } from 'views/Login/constants'
import { NAME as ROUTE_PROFILE } from 'views/Profile/constants'
import { ROUTE_LOGOUT } from 'state/routes'

import userIcon from 'assets/user-icon.png'

import styles from './styles.css'

class Header extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    fullWidth: PropTypes.bool,
    linksLeft: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      }),
    ).isRequired,
    linksRight: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        href: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
          .isRequired,
      }),
    ),
    account: PropTypes.oneOfType([
      PropTypes.bool.isRequired,
      PropTypes.object.isRequired,
    ]),
  }

  static defaultProps = {
    className: '',
    fullWidth: true,
    linksRight: [],
    account: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      mobileMenuActive: 'auto',
    }
  }

  getClassName() {
    return classnames(styles.root, this.props.className, {
      fullwidth: this.props.fullWidth,
    })
  }

  toggleMobileMenu(id) {
    this.setState(prev => ({
      mobileMenuActive: prev.mobileMenuActive === id ? null : id,
    }))
  }

  render() {
    const { linksLeft, linksRight, account } = this.props

    // Let the mobile login/signup menu be open on page load if not logged in.
    const mobileMenuActive =
      this.state.mobileMenuActive === 'auto'
        ? account
          ? null
          : 'right'
        : this.state.mobileMenuActive

    return (
      <header className={this.getClassName()}>
        <Container
          size={this.props.fullWidth ? 'full' : 'large'}
          className={styles.container}
        >
          <FontAwesomeIcon
            icon={faBars}
            className={styles.hamburger}
            onClick={() => this.toggleMobileMenu('left')}
          />

          <div className={styles.navs}>
            <Link className={styles.logo} href={reverse(ROUTE_HOME)}>
              <SvgSiteLogo />
            </Link>
            <LinkNav links={linksLeft} className={styles.desktopNavs} />
          </div>

          <div className={classnames(styles.navs, styles.desktopNavs)}>
            <LinkNav links={linksRight} />
            {this.props.children}
          </div>
          <img
            className={styles.avatar}
            src={userIcon}
            alt=""
            onClick={() => this.toggleMobileMenu('right')}
          />
        </Container>
        <Container
          size={this.props.fullWidth ? 'full' : 'large'}
          className={classnames(styles.container, styles.mobileContainer, {
            [styles.active]: mobileMenuActive,
          })}
        >
          {mobileMenuActive === 'left' && (
            <nav>
              <ul className={styles.mobileNavs}>
                {linksLeft.map(link => (
                  <li key={link.label}>
                    <Link className={styles.link} {...link} />
                  </li>
                ))}
              </ul>
            </nav>
          )}
          {mobileMenuActive === 'right' && (
            <nav>
              <ul className={styles.mobileNavs}>
                {linksRight.map(link => (
                  <li key={link.label}>
                    <Link className={styles.link} {...link} />
                  </li>
                ))}
                {account == null && (
                  <React.Fragment>
                    <li>
                      <Link className={styles.link} href={reverse(ROUTE_LOGIN)}>
                        Logga in
                      </Link>
                    </li>
                  </React.Fragment>
                )}

                {account && (
                  <React.Fragment>
                    <li>
                      <Link
                        className={styles.link}
                        href={reverse(ROUTE_FIND_ACTIVITY)}
                      >
                        Hitta aktivitet
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={styles.link}
                        href={reverse(ROUTE_PROFILE)}
                      >
                        Min sida
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={styles.link}
                        href={reverse(ROUTE_LOGOUT)}
                      >
                        Logga ut
                      </Link>
                    </li>
                  </React.Fragment>
                )}
              </ul>
            </nav>
          )}
        </Container>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ../source/layouts/Header/index.js